import React, { useEffect, useRef, useState }  from "react";
import axios from "axios";
import Constants from "../Utilities/Constants";
import * as signalR from "@microsoft/signalr";
import { useAppContext } from '../Contexts/AppContext';

const mapResponseToMessage = (code) => {
    switch ((code || '').toString()) {
        case '002': return 'על פי חברת כרטיס האשראי של הלקוח/ה הכרטיס גנוב ועליך להחרים אותו.';
        case '003':
        case '004': return 'חברת כרטיס האשראי לא אישרה את החיוב. ניתן לנסות כרטיס אחר.';
        case '006': return 'תקלה במספר ה-CVV. יש לוודא שהספרות הוזנו בצורה מדויקת.';
        case '026': return 'מספר תעודת הזהות שגוי או אינו תואם לכרטיס. יש להזין מספר תעודת זהות חדש.';
        case '322': return 'אין הרשאה לביצוע עסקת J5.';
        case '344': return 'אין הרשאה לאשראי - הרשאת מנפיק.';
        case '447': return 'מספר כרטיס האשראי שגוי. אנא הזינו מחדש.';
        default:    return 'שגיאה לא ידועה. אנא נסו שנית.';
    }
};

const Payment = ({ data, setComponent }) => {

    const { setPaymentResult, setCart } = useAppContext();
    const account = Constants.TRANZILA_ACCOUNT;
    const cred_type = 1;
    const maxpay = 1;
    const totalOrder = data.totalOrder.toFixed(2);
    const orderId = data.orderId;
    const connectionRef = useRef(null);
    const resolvedRef = useRef(false);
    const [errorMsg, setErrorMsg] = useState(null);


    const handleSuccess = (setCart, setComponent) => {
        if (resolvedRef.current) return;
        resolvedRef.current = true;
        setCart([]);
        setComponent("PaymentSuccess");
    };

    const handleFailure = (msg, setPaymentResult) => {
        setPaymentResult({
            orderId: msg.orderId,
            response: msg.Response || msg.response,
            errorMsg: msg.errorMsg || msg.message,
            success: false
        }, true);
        const text = msg.errorMsg || msg.message || mapResponseToMessage(msg.Response || msg.response);
        setErrorMsg(text);
    };


    useEffect(() => {

        if (!orderId) return;

        resolvedRef.current = false;
        let stopped = false;

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`${Constants.API_URL}/hubs/payment`, { withCredentials: true })
            .withAutomaticReconnect()
            .build();

        connectionRef.current = connection;

        connection.start()
            .then(async () => {
                if (stopped) return;
                await connection.invoke("JoinOrder", orderId.toString());
            })
            .catch(err => { if (!stopped) console.error("SignalR error:", err); });

        connection.on("paymentResult", msg => {
            if (msg.orderId !== orderId) return;
            if (msg.success)
                handleSuccess(setCart, setComponent);
            else
                handleFailure(msg, setPaymentResult);
        });

        // Polling fallback — in case SignalR event is missed
        const pollInterval = setInterval(async () => {
            if (resolvedRef.current) { clearInterval(pollInterval); return; }
            try {
                const { data } = await axios.get(`${Constants.API_URL}/Order/${orderId}`);
                if (data?.orderStatus === 1)
                    handleSuccess(setCart, setComponent);
            } catch { /* ignore poll errors */ }
        }, 5000);

        return () => {
            stopped = true;
            connection.stop();
            clearInterval(pollInterval);
        };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderId, setComponent, setPaymentResult, setCart]);

    return (
        <>
        <div className="m-1">
            <div className="d-flex justify-content-between border-bottom border-success">
                <h4>תשלום מאובטח</h4>
                <h4>
                    <button
                        className="align-left"
                        title="חזור"
                        onClick={() => setComponent && setComponent('VerifyStock')}
                    >
                        {'<<'}
                    </button>
                </h4>
            </div>

            <div className="fw-bold text-success">
                <span>{totalOrder} ש"ח </span>
            </div>

            {Constants.ENVIRONMENT === 'development' ? (
                <iframe
                    src={`http://localhost:3000/test-tranzila2.html?orderId=${orderId}&sum=${totalOrder}`}
                    className="ccard"
                    title="Credit card - test"
                />
            ) : (
                <iframe
                    src={`https://direct.tranzila.com/${account}/iframenew.php?currency=1&cred_type=${cred_type}&maxpay=${maxpay}&tranmode=V&sum=${totalOrder}&orderid=${orderId}&lang=il&nologo=0&trButtonColor=da4498`}
                    className="ccard"
                    title="Credit card"
                />
            )}
        </div>

        {errorMsg && (
            <>
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header bg-danger text-white">
                                <h5 className="modal-title">התשלום נדחה</h5>
                            </div>
                            <div className="modal-body text-center">
                                <p className="mb-0">{errorMsg}</p>
                            </div>
                            <div className="modal-footer justify-content-center">
                                <button className="btn btn-primary" onClick={() => setErrorMsg(null)}>
                                    נסה שוב
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </>
        )}
        </>
    );
};

export default Payment;
